import { Component } from '@angular/core';

@Component({
  selector: 'gallery-images',
  standalone: true,
  imports: [],
  templateUrl: './gallery.component.html',
  styleUrl: './gallery.component.scss'
})
export class GalleryComponent {

}
